import type { Entry } from './interface'
import { TrackEventCategory } from './interface'
import { trackEvent } from './utils'

export default class Click {
  add(entry: Entry): void {
    entry.el.addEventListener('click', () => {
      if (window._paq) {
        const { action = 'click', name, value } = entry.value
        // console.log(`🚀 埋点触发 - 事件类型:${TrackEventCategory.Click}, 事件行为:${action}, 事件名称:${name || '-'}, 事件值:${value || '-'}`)
        trackEvent(TrackEventCategory.Click, { action, name, value })
      }
      else {
        console.warn('window._paq is not defined')
      }
    })
  }
}
